<template>
  <b-card
    class="user__accordion"
    no-body
  >
    <template slot="header">
      <div
        class="header-toggle"
        @click="toggle"
      >
        <b>{{ user.displayName }}</b>
        <b-spinner
          v-if="isLoading"
          class="accordion__spinner"
          type="grow"
        />
        <font-awesome-icon
          v-else
          :icon="['fas', !isOpen ? 'chevron-down' : 'chevron-up']"
          class="float-right"
        />
      </div>
    </template>
    <b-collapse v-model="isOpen">
      <template v-if="isOpen">
        <template v-if="isCurrentUserIsAdmin">
          <b-alert
            class="admin__alert-message"
            show
            variant="info"
          >
            This user is an administrator and you cannot control his or her access rights
          </b-alert>
        </template>
        <div
          v-else
          class="cards__container"
        >
          <permission-card
            :local-permissions="permissions"
            text="Modules"
            type="modules"
            :user="user"
            @change-local-permissions="changeLocalPermissions"
            @remove-from-local-permissions="removeFromLocalPermissions"
          />
          <permission-card
            :local-permissions="permissions"
            text="Folders"
            type="folders"
            :user="user"
            @change-local-permissions="changeLocalPermissions"
            @remove-from-local-permissions="removeFromLocalPermissions"
          />
          <permission-card
            :local-permissions="permissions"
            text="Tables"
            type="tables"
            :user="user"
            @change-local-permissions="changeLocalPermissions"
            @remove-from-local-permissions="removeFromLocalPermissions"
          />
        </div>
      </template>
    </b-collapse>
  </b-card>
</template>

<script>

import {createNamespacedHelpers} from 'vuex';
import PermissionCard from '@/modules/Security/components/PermissionCardComponents/PermissionCard.vue';

const {mapActions: dataManagementMapActions} = createNamespacedHelpers('dataManagement');
const {mapState: userMapState} = createNamespacedHelpers('user');

export default {
  name: 'UserComponent',
  components: {PermissionCard},
  props: ['user'],
  data() {
    return {
      isLoading: false,
      isOpen: false,
      userId: null,
      permissions: null,
      currentUserPermission: null,
    };
  },
  computed: {
    ...userMapState({
      usersPermissions: state => state.usersPermissions,
    }),
    isCurrentUserIsAdmin() {
      return this.currentUserPermission === 'admin';
    },
  },
  methods: {
    ...dataManagementMapActions(['getPermissionsByUserGuid']),
    changeLocalPermissions(data) {
      this.permissions.push(data);
    },
    async prepareData() {
      this.isLoading = true;
      this.permissions = await this.getPermissionsByUserGuid(this.userId);
      this.isLoading = false;
    },
    async toggle() {
      if (!this.isOpen) {
        await this.prepareData(this.user);
        if (this.permissions) {
          this.isOpen = !this.isOpen;
        }
      } else {
        this.isOpen = false;
      }
    },
    removeFromLocalPermissions(id) {
      this.permissions = this.permissions.filter(el => (
        el.objectGuid !== id
      ));
    },
  },
  mounted() {
    this.userId = this.user.id;
    this.currentUserPermission = this.usersPermissions[this.userId]?.role;
  },
};
</script>

<style scoped lang="scss">
.cards__container {
  padding: 5px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 5px;
  height: 500px;

  @media (max-width: 1200px) {
    grid-template-columns: none;
    height: 1000px;
    row-gap: 5px;
  }
}

.user__accordion {
  .card-header {
    padding: 0;
  }

  .header-toggle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: .75rem 1.25rem;
  }

  &:not(:last-child) {
    margin-bottom: 10px;
  }
}

.accordion__spinner {
  width: 1rem;
  height: 1rem;
}

.admin__alert-message {
  margin-bottom: 0;
  padding: 20px;
  border-radius: 0;
  font-size: 1.2em;
}
</style>